import { useState } from "react";
import { useAppDispatch } from "../utils";
import { citizenApi } from "../api/citizenApi";
import { downloadFileFromUrl } from "../utils/download";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";

export const useCollectionYardVisitsReceipts = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslation();

  const downloadReceiptsZip = async (visitIds: number[]) => {
    if (visitIds.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const response = await dispatch(
        citizenApi.endpoints.postCollectionYardVisitsReceiptsUrl.initiate({ visitIds })
      ).unwrap();

      const fileName = `${t("receiptsArchive")}.zip`;
      downloadFileFromUrl(response.fileUrl, fileName, response.base64);
      enqueueSnackbar(t("receiptsDownloadSuccess"), { variant: "success" });
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      setError(message || "Failed to download receipts archive");
      enqueueSnackbar(t("errors.receiptExportError"), { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return { downloadReceiptsZip, loading, error } as const;
};
